import styled from "styled-components";

// import colors from '../../constants/colors'
import breakpoints from '../../constants/breakpoints'
// import fonts from '../../constants/fonts'

export const Wrap = styled.div`
  & > h5 {
    color: #f5a462;
    font-size: 19px;
    line-height: 36px;
    font-weight: 600;
    @media screen and (max-width: ${breakpoints.ipad.pixels}) {
      margin-top: 8px;
    }
  }
`;
